import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { Nav, NavItem } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { IoChevronBack, IoDocumentText, IoDocument } from "react-icons/io5";
import MenuFooter from "./MenuFooter";

class CallMenu extends Component {
  render() {
    const { call, onClickMenu } = this.props;

    return (
      <Nav className="sidebar sidebar-nav">
        <LinkContainer
          to="#"
          onClick={this.props.history.goBack}
          style={{ margin: "0 15px" }}
        >
          <NavItem eventKey={1} onClick={onClickMenu}>
            <IoChevronBack size={16} />
            Back
          </NavItem>
        </LinkContainer>
        <LinkContainer exact to={`/app/calls/${call._id}`}>
          <NavItem eventKey={2} onClick={onClickMenu}>
            <IoDocumentText size={15} />
            <span>Call Info</span>
          </NavItem>
        </LinkContainer>
        <LinkContainer exact to={`/app/calls/${call._id}/notes`}>
          <NavItem eventKey={3} onClick={onClickMenu}>
            <IoDocument size={15} />
            <span>Call Notes</span>
          </NavItem>
        </LinkContainer>
        <MenuFooter />
      </Nav>
    );
  }
}

CallMenu.propTypes = {
  call: PropTypes.object,
  onClickMenu: PropTypes.func,
  history: PropTypes.object
};

function mapStatesToProps(state) {
  return {
    state,
    call: state.reducers.call,
    router: state.reducers.router
  };
}

export default connect(mapStatesToProps)(CallMenu);
